import NumbersIcon from '@mui/icons-material/Numbers';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import React from 'react';
const getInputAdornmentWithContent = (content) => React.createElement(InputAdornment, { position: "start" }, content);
export function InputStartAdornment({ type, currency, customStartAdornment }) {
    if (customStartAdornment) {
        return getInputAdornmentWithContent(customStartAdornment);
    }
    if (type === 'money') {
        return React.createElement(InputAdornment, { position: "start" }, currency || '$');
    }
    if (type === 'search') {
        return (React.createElement(InputAdornment, { position: "start" },
            React.createElement(SearchIcon, { color: "action", fontSize: "small" })));
    }
    if (type === 'hex') {
        return (React.createElement(InputAdornment, { position: "start" },
            React.createElement(NumbersIcon, { color: "secondary", fontSize: "small" })));
    }
    return null;
}
//# sourceMappingURL=InputStartAdornment.js.map